import { ITextInputProps } from './TextInput';
import { MaskedInput } from './MaskedInput';

export const CPFInput: React.FC<Partial<ITextInputProps>> = (props) => {
  return (
    <MaskedInput
      name="cpf"
      id="cpf"
      label="CPF"
      placeholder="___.___.___-__"
      mask="###.###.###-##"
      {...props}
    />
  );
};

